import { Paper } from "@mui/material";
import React from "react";
import { connect } from "react-redux";
import DynamicMainScreen from "../../components/dynamicscreens/DynamicMainScreen";
import endpoint from "../../config/endpoints";
import {
  cancelLeaveMsg,
  noInternetMsg,
  serverMsg,
  statusmsg
} from "../../config/messageconstant";
import { MyLeaveJson } from "../../DynamicFormsJson/MastersJSON/myLeave";
import { getClaimDetailsForDayEndBeats } from "../../Slice/beat.slice";
import { getApprovalCount, getLeaveSearch } from "../../Slice/LeaveType.slice";
import {
  MyLeaveColumns,
} from "../../tableColumns/table-columns";
import { apiGet } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import MyLeaveViewPopup from "./MyLeaveViewPopUp";

class MyLeaveTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      claimDetailsData: {},
      viewPopup: false,
      viewData: {},
      claimApplyDetails: [],
      DataToSet: [],
      fixedCalculation: "",
    };
  }

  async componentDidMount() {
    await this.getData();
  }

  getData = async () => {
    const { getApprovalCount, showLoador, showNotification } = this.props;

    if (navigator.onLine) {
      showLoador({ loador: true });
      await getApprovalCount().then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onSearchList = (data) => {
    const { getLeaveSearch, showLoador, showNotification } = this.props;
    if (navigator.onLine) {

      showLoador({ loador: true });
      getLeaveSearch({
        monthYear: data.month,
      }).then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  rowViewData = (rowData) => {
    const { showLoador, showNotification } = this.props;
    showLoador({ loador: true });
    apiGet({
      url: endpoint.leaveApply + "/" + rowData.id,
    }).then(({ data, success }) => {
      console.log(data)
      showLoador({ loador: false });
      if (success) {
        this.setState({
          viewData: data.data,
          DataToSet: [
            {
              xs: 12,
              sm: 6,
              md: 6,
              lg: 6,
              label: "Leave Type",
              value: data.data.leaveType !== null &&
                data.data.leaveType.name !== null ? data.data.leaveType.name : "-",
            },
            {
              xs: 12,
              sm: 6,
              md: 6,
              lg: 6,
              label: "No. Of Days",
              value: data.data.noOfDays !== null ? data.data.noOfDays : "-",
            },
            {
              xs: 12,
              sm: 6,
              md: 6,
              lg: 6,
              label: "Status",
              value: data.data.status !== null ?
                data.data.status == 0 ? "Pending" :
                  data.data.status == 2 ? "Approved" :
                    data.data.status == 3 ? "Rejected" : "Cancelled" : "-",
            },
            {
              xs: 12,
              sm: 6,
              md: 6,
              lg: 6,
              label: "Subject",
              value: data.data.leaveReason !== null ? data.data.leaveReason : "-",
            },
            {
              xs: 12,
              sm: 6,
              md: 6,
              lg: 6,
              label: "Start Date",
              value: data.data.fromDate !== null ? data.data.fromDate : "-",
            },
            {
              xs: 12,
              sm: 6,
              md: 6,
              lg: 6,
              label: "End Date",
              value: data.data.toDate !== null ? data.data.toDate : "-",
            },
            {
              xs: 12,
              sm: 6,
              md: 6,
              lg: 6,
              label: "Description",
              value: data.data.description !== null ? data.data.description : "-",
            },
          ],
          viewPopup: true,
        });
      }

    });
  }

  handleClosesCategory = () => {
    this.setState({
      viewPopup: false,
    });
  };

  rowCancel = (rowData) => {
    const { showLoador, showNotification } =
      this.props;

    swal({
      title: "Are you sure?",
      text: cancelLeaveMsg,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        showLoador({ loador: true });

        const statusCode = 1;

        apiGet({
          url:
            endpoint.leaveApply +
            "/update-status?leaveApplyId=" +
            rowData.id +
            "&status=" +
            statusCode,
        }).then(({ data, success }) => {
          if (!success) {
            showLoador({ loador: false });
            showNotification({
              msg: serverMsg,
              severity: "error",
            });
          } else {
            showNotification({ msg: statusmsg });
            this.getData();
          }
        });
      }
    });
  };

  render() {
    const { leaveList, beatList, getApprovalCount } = this.props;
    const {
      viewPopup,
      viewData,
      DataToSet,
    } = this.state;

    return (
      <>
        <Paper
          sx={{
            padding: 2,
          }}
          elevation={0}
        >
          <DynamicMainScreen
            formPath={MyLeaveJson.formPath}
            screenTitle={MyLeaveJson.screenTitle}
            fieldMeta={MyLeaveJson.fieldMeta}
            showPdfDownload={MyLeaveJson.showPdfDownload}
            showExcelDownload={false}
            showExtension={false}
            pdfFileName={MyLeaveJson.pdfFileName}
            excelFileName={MyLeaveJson.excelFileName}
            showAddButton={MyLeaveJson.showAddButton}
            tableColumnsToFilter={MyLeaveJson.tableColumnsToFilter}
            tableColumns={MyLeaveColumns}
            tableData={leaveList?.leaveApply}
            getTableData={getApprovalCount}
            apiBaseURL={MyLeaveJson.apiBaseURL}
            baseIdColumn={MyLeaveJson.baseIdColumn}
            showDeleteIcon={false}
            showViewButtonInTable={true}
            showFilterIcon={true}
            onSearchData={this.onSearchList}
            searchList={MyLeaveJson.searchList}
            rowView={this.rowViewData}
            staticView={true}
            showCancel={true}
            showCancelTitle={"Cancel Leave"}
            rowCancel={this.rowCancel}
            editConditionName="status"
            editConditionValue="0"
            cancelBillConditionName="status"
            cancelBillConditionValue="0"
            callApi={false}
            getTableDataById={true}
          />
        </Paper>
        {viewPopup && (
          <MyLeaveViewPopup
            open={viewPopup}
            handleCloses={this.handleClosesCategory}
            DataToSet={DataToSet}
            viewData={viewData}
          />
        )}
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  ClaimList: state.claim,
  beatList: state.beat,
  leaveList: state.leaveType,
});
const mapDispatchToProps = {
  getClaimDetailsForDayEndBeats,
  showLoador,
  showNotification,
  getApprovalCount,
  getLeaveSearch,
};
export default connect(mapStateToProps, mapDispatchToProps)(MyLeaveTable);
